/**
 * @deprecated Use `useMessage(m => <condition>)` instead. This will be removed in 0.6.
 */
export { useMessageIf } from "./useMessageIf";
